import { render, staticRenderFns } from "./addBankCard.vue?vue&type=template&id=0cae5ce7&scoped=true&"
import script from "./addBankCard.vue?vue&type=script&lang=js&"
export * from "./addBankCard.vue?vue&type=script&lang=js&"
import style0 from "./addBankCard.vue?vue&type=style&index=0&id=0cae5ce7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae5ce7",
  null
  
)

export default component.exports